import { useCallback, useEffect, useState } from 'react';

const useModalSections = ({ open, initialSection, resetDelayMs = 0 }) => {
  const [section, setSection] = useState(initialSection);

  useEffect(() => {
    if (open) return undefined;

    const resetSection = () => {
      setSection(initialSection);
    };

    if (resetDelayMs <= 0) {
      resetSection();
      return undefined;
    }

    const resetTimeout = window.setTimeout(resetSection, resetDelayMs);
    return () => {
      window.clearTimeout(resetTimeout);
    };
  }, [initialSection, open, resetDelayMs]);

  const goToSection = useCallback((nextSection) => {
    setSection(nextSection || initialSection);
  }, [initialSection]);

  const goBack = useCallback(() => {
    setSection(initialSection);
  }, [initialSection]);

  return {
    section,
    isNested: section !== initialSection,
    goToSection,
    goBack,
  };
};

export default useModalSections;
